/**
 * SearchableDropdown — generic filterable select used inside the work
 * order builder for picking equipment / parts / scopes by typing.
 * Optionally exposes "+ Add {query}" when the parent supplies an
 * `onAddNew` handler.
 *
 * Extracted from `components/WorkOrderTab.jsx` to slim the file (was
 * 2,886 lines before — this extract drops it by ~30 lines).
 */
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export function SearchableDropdown({ items, onChange, placeholder, onAddNew }) {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const filtered = items.filter(i => i.name.toLowerCase().includes(search.toLowerCase()));
  return (
    <div className="relative">
      <div className="relative flex-1">
        <Input value={search} onChange={(e) => { setSearch(e.target.value); setOpen(true); }}
          onFocus={() => setOpen(true)} placeholder={placeholder} className="h-8 text-xs pr-7" />
        <Search className="w-3 h-3 absolute right-2 top-2.5 text-slate-400" />
      </div>
      {open && (
        <div className="absolute z-50 w-full mt-1 bg-white border rounded-md shadow-lg max-h-40 overflow-y-auto">
          {filtered.map(item => (
            <button key={item.id || item.name} type="button" className="w-full text-left px-3 py-1.5 text-xs hover:bg-slate-100 truncate"
              onClick={() => { onChange(item); setSearch(""); setOpen(false); }}>{item.name}</button>
          ))}
          {filtered.length === 0 && <div className="px-3 py-2 text-xs text-slate-400">No results</div>}
          {onAddNew && search.trim() && (
            <button type="button" className="w-full text-left px-3 py-1.5 text-xs text-blue-600 hover:bg-blue-50 border-t"
              onClick={() => { onAddNew(search.trim()); setSearch(""); setOpen(false); }}>+ Add "{search.trim()}"</button>
          )}
        </div>
      )}
      {open && <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />}
    </div>
  );
}
